import { createFileRoute } from '@tanstack/react-router'

import { WorkflowPage } from '@/pages/workflow/Workflow.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow',
)({
  component: WorkflowPage,
  loader: () => ({ breadcrumbTitle: 'Workflow' }),
})
